<template>
	<div>
		<div class="align-center d-flex justify-space-between pb-2">
			<h5>Pass Description</h5>
			<v-btn color="secondary" depressed icon small @click.stop="dialog = true">
				<v-icon small>mdi-dock-window</v-icon>
			</v-btn>
		</div>
		<div :class="`description line-clamp-${lines} text-body-2`"
				 :inner-html.prop="description"></div>

		<v-dialog v-model="dialog" content-class="rounded-xl" scrollable width="600px">
			<v-card class="position-relative" rounded="xl">
				<v-card-title class="d-flex justify-space-between">
					<h6>{{ title }}</h6>
					<v-btn
							class="mt-n1 me-n2"
							color="primary"
							depressed
							icon
							@click="dialog = false"
					>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text
						class="text-body-2"
						:inner-html.prop="description"
				></v-card-text>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
export default {
	name: 'PassDescription',
	props: {
		invite: {
			type: Object,
			default: () => ({})
		},
		lines: {
			type: Number,
			default: 4
		}
	},
	data() {
		return {
			description: this.invite.dealDescription,
			dialog: false,
			title: this.invite.dealName
		};
	}
};
</script>

<style lang="scss" scoped>
.description {
	position: relative;

	&::after {
		background: linear-gradient(to top, #FFF, rgba(255, 255, 255, 0) 50%);
		content: '';
		height: 100%;
		left: 0;
		pointer-events: none;
		position: absolute;
		top: 0;
		width: 100%;
		z-index: 1;
	}
}
</style>
